import React from "react";
import PropTypes from "prop-types";
import PureModal from "components/ui/modal/pure-modal";
import { aLink } from "utils/styles";
import { LoginHistoryModal } from "./login-history-modal";
import { formatDuration } from "./format-duration";

export const TotalTimeRow = ({ data }) => {
  return (
    <td className="total-row">
      <PureModal
        windowProps={{ modalWidth: "600px" }}
        renderTrigger={({ openModal }) => (
          <div className="key-row"
            style={{...aLink, marginBottom: "3px", marginTop: "12px"}}
            onClick={() => {
              openModal();
            }}
          >
           <div>Connection: {formatDuration(data?.totalConnectionTime)}</div>
           <div className="connection-color-indicator"></div>
          </div>
        )}
      >
        <LoginHistoryModal
          data={data?.connectionData || []}
          total={data?.totalConnectionTime || ""}
          coach={data?.coachName}
          type="Connection"
        />
      </PureModal>
      <PureModal
        windowProps={{ modalWidth: "600px" }}
        renderTrigger={({ openModal }) => (
          <div
          className="key-row"
            style={aLink}
            onClick={() => {
              openModal();
            }}
          >
           <div> AutoDialer: {formatDuration(data?.totalAutoDialerTime)}</div>
            <div className="autodialer-color-indicator"></div>
          </div>
        )}
      >
        <LoginHistoryModal
          data={data?.autodialerData || []}
          total={data?.totalAutoDialerTime || ""}
          coach={data?.coachName}
          type="AutoDialer"
        />
      </PureModal>
    </td>
  );
};

TotalTimeRow.propTypes = {
  data: PropTypes.object.isRequired
};
